var map = {
	"./data-management-experience.mdx": [
		8026,
		5645
	],
	"./download-experience-redesign.mdx": [
		7242,
		7242
	],
	"./open-data-platform-redesign.mdx": [
		3314,
		3314
	],
	"./pulse-analytics-dashboard.mdx": [
		1428,
		1428
	],
	"./scalable-vector-icon-system.mdx": [
		5759,
		5759
	],
	"./visual-qa.mdx": [
		8020,
		8020
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3305;
module.exports = webpackAsyncContext;